import { useForm } from "react-hook-form";
import { ConsumidoresFrm } from "../../models/ConsumidoresFrm"
import { ConsumidorFrmService } from "../../service/ConsumidorFrmService";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { useToken } from "../../components/useToken";
import { Dialog } from "primereact/dialog";
import { Toolbar } from "primereact/toolbar";
import { Envio } from "./Envio";
import { Generico } from "../../components/Generico";

export const Formulario = ({ id, clienteEmpresaId, generic, toast, permss, empresa, tipo, opcion }) => {

    const omodel = new ConsumidoresFrm();
    const { accionesTbl, estadosSiNo } = Generico();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const [forms, setForms] = useState(null);
    const formService = new ConsumidorFrmService();
    const [catalogo, setCatalogo] = useState(null);
    const [dialogNotificacion, setDialogNotificacion] = useState(false);
    const [dialogEnvio, setDialogEnvio] = useState(false);
    const [notificacion, setNotificacion] = useState(null);
    const { getRol } = useToken();
    const { table, setLoading, setTotalRecords, lazyParams, inDrop, inCalendar, inArea } =
        InputComponent({ registers: forms, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        let _lazyParams = lazyParams;
        _lazyParams.ids = id;
        _lazyParams.tipo = tipo;
        delete _lazyParams.catalogo;
        delete _lazyParams.empresa;
        if (empresa) {
            _lazyParams.empresa = empresa;
        }
        const rol = getRol();
        if (!rol) {
            toast.current.show({ severity: 'warn', summary: 'Rol no seleccionado', detail: 'Por favor selecciona un rol antes de continuar.', life: 3000 });
            setLoading(false);
            return;
        } else {
            _lazyParams.rol = rol;
        }
        if (catalogo == null) {
            _lazyParams.catalogo = 'lista';
        }
        formService.getForm({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setForms(res.data.registros);
            setLoading(false);
            if (catalogo == null) {
                setCatalogo(res.data.catalogo);
            }
        }).catch(error => {
            setLoading(false);
            generic.funcSistemaError(error, toast);
        });
    }

    const onSubmit = (data) => {
        data.ids = id;
        data.fecha = generic.dateToString(data.fecha);
        if (getRol()?.id && getRol()?.idr) {
            data.idr = getRol()?.idr;
        }
        if (getRol()?.id) {
            data.rol = getRol()?.id;
        }
        if (data.empresa == null) {
            data.empresa = { cat_id: clienteEmpresaId };
        }

        const request = getValues('id') == null ? formService.newForm(data) : formService.editarForm(data);
        request.then(res => {
            generic.funcSuccess(res, toast);
            cerrarDialogNotificacion();
            loadLazyData();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    }

    const editForm = () => {
        formService.consultarForm(notificacion?.id, 0).then(res => {
            const _form = res.data.formulario;
            _form.fecha = generic.stringToDate(_form.fecha);
            reset(generic.renewValues(_form, omodel.model));
            setDialogNotificacion(true);
        }).catch(error => {
            generic.funcSistemaError(error, toast);
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación eliminación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarForm()
        });
    }

    const eliminarForm = () => {
        formService.eliminarForm(notificacion?.id).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const enviar = () => {
        confirmDialog({
            message: '¿Está seguro de enviar la notificación?',
            header: 'Confirmación envío',
            icon: 'pi pi-exclamation-triangle',
            accept: () => notificar()
        });
    }

    const notificar = () => {
        setLoading(true);
        const _data = notificacion;
        _data.ids = id;
        formService.notificar(_data).then(res => {
            setLoading(false);
            generic.funcSuccess(res, toast);
        }).catch(error => {
            setLoading(false);
            generic.funcDeleteError(error, toast);
        })
    }

    const cerrarDialogNotificacion = () => {
        setDialogNotificacion(false);
    }

    const openNew = () => {
        setNotificacion(null);
        reset(defaultValues);
        setDialogNotificacion(true);
    }

    const showNotificacion = () => {
        setDialogEnvio(true);
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && !['Finalizado', 'Cancelado', 'Eliminado'].includes(notificacion?.estadof))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editForm() } });
        if (permss?.actualizar && (!notificacion?.estadof || notificacion?.estadof === 'Borrador'))
            items.push({ label: 'Enviar notificación al correo.', icon: 'pi pi-send', command: () => { enviar() } });
        if (permss?.consultar)
            items.push({ label: 'Notificaciones enviadas', icon: 'pi pi-book', command: () => { showNotificacion() } });
        if (permss?.eliminar && !notificacion?.estadof)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const siOpcion = (strOpcion, crud) => {
        return crud && (opcion === 'PRELAFIT' || opcion.includes(strOpcion));
    }

    return (
        <>
            <Card title="Favor leer las siguientes instrucciones de uso:">
                {omodel.aviso}
            </Card>
            <br />

            <Card title="Lista de formularios">
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nuevo', permss)}></Toolbar>
                {table({ action01: accionesTbl, reg: setNotificacion, items: itemsMenu() })}
            </Card>

            <Dialog visible={dialogNotificacion} header={getValues('id') == null ? "Nuevo envío de formulario" : "Editar envío de formulario"} modal
                className="p-fluid modal-ssize" onHide={e => cerrarDialogNotificacion()} style={{ maxWidth: '800px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inDrop('formulario', catalogo?.forms, { lab: omodel.optionLabel }, 6)}
                        {inDrop('estado_cf', estadosSiNo, { lab: omodel.optionLabel }, 6)}
                        {inCalendar('fecha', { min: 'min', minNull: 'check' }, 6)}
                        {siOpcion('consumidor-empresas', permss?.actualizar) && inDrop('grupo', catalogo?.grupo, { lab: omodel.optionLabel, obl: "" }, 6)}
                        {inArea('observacion', 3, 9, 12)}
                        {catalogo?.empresas?.length > 0 && inDrop('empresa', catalogo?.empresas, { lab: omodel.optionLabel }, 6)}
                    </div>
                    <br />
                    {generic.buttonsForms(cerrarDialogNotificacion)}
                </form>
            </Dialog>

            <Dialog visible={dialogEnvio} header="Notificaciones enviadas" modal
                className="p-fluid modal-ssize" onHide={e => setDialogEnvio(false)} style={{ maxWidth: '800px' }}>
                <Envio id={notificacion?.id} service={formService} permss={permss} />
            </Dialog>
        </>
    )
}
